var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('edit-form-embed',{attrs:{"config":_vm.config,"parentType":_vm.parentType,"disabled":_vm.disabled,"readOnly":_vm.readOnly,"inlineFormControls":""},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }